const ProblemSolution = () => (
    <section className="ps" id="goals">
        <div className="gt-container ps__grid">
            <div data-reveal>
                <span className="eyebrow">GOALS</span>
                <h2>A list is not a plan.</h2>
                <p>Goals need time. General Task shows the week you actually have.</p>
            </div>
        </div>
    </section>
)

export default ProblemSolution
